import React, { useRef } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";

interface HCaptchaWidgetProps {
  siteKey: string;
  onVerify: (token: string) => void;
  onExpire?: () => void;
  onError?: () => void;
}

export const HCaptchaWidget: React.FC<HCaptchaWidgetProps> = ({
  siteKey,
  onVerify,
  onExpire,
  onError,
}) => {
  const captchaRef = useRef<HCaptcha | null>(null);


  const handleVerify = (token: string) => {
    onVerify(token);
  };

  const handleExpire = () => {
    onExpire?.();
  };

  const handleError = () => {
    onError?.();
  };
  return (
    <HCaptcha
      sitekey={siteKey}
      onVerify={handleVerify}
      onExpire={handleExpire}
      onError={handleError}
      ref={captchaRef}
    />
  );
};
